import { Button, DraggableWindowHeader } from "@hoylu/client-common";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashboardOption } from "@/enums/DashboardOption.enum";
import { callWithLoginConfirm } from "../../state/user/user.actions";
import { user } from "../../state/user/user.selector";
import {
  activateDashboardOption,
  cancelDashboardOption,
} from "../../state/workspaces/workspaces.actions";
import { Localized } from "../../strings";
import { managementPortalUserProfileUrl } from "../../utils/management.portal/management.portal.url.selectors";
import { openManagementPortal } from "../../utils/management.portal/openManagementPortal";
import Styles from "./ManageAccount.module.css";
import { Modal } from "./Modal";

export const ManageAccount = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(user);
  const userProfileUrl = useSelector(managementPortalUserProfileUrl);

  const strings = Localized.object("MANAGE_ACCOUNT");
  const tClose = Localized.object("CLOSE_BUTTON");
  const close = useCallback(
    () => dispatch(cancelDashboardOption()),
    [dispatch],
  );
  return (
    <Modal handleOutsideClick={close}>
      <DraggableWindowHeader
        close={tClose.CLOSE}
        onClose={close}
        title={strings.TITLE}
      />
      <div className={Styles.manageAccount}>
        <div className={Styles.row}>
          <span>{strings.EMAIL}</span>
          <span>{currentUser.profile.email}</span>
        </div>
        <div className={Styles.row}>
          <span>{strings.CREATED}</span>
          {currentUser.profile.createdTime && (
            <span>
              {new Date(currentUser.profile.createdTime).toLocaleDateString()}
            </span>
          )}
        </div>
      </div>
      <div className={Styles.footer}>
        <Button
          onClick={() =>
            dispatch(
              callWithLoginConfirm({
                accept: activateDashboardOption({
                  optionType: DashboardOption.CONFIRM_ACCOUNT_DELETE,
                }),
                reject: cancelDashboardOption(),
              }),
            )
          }
          toolTip={strings.DELETE}
          type="secondary"
        >
          {strings.DELETE + "..."}
        </Button>
        <Button
          onClick={() => openManagementPortal(userProfileUrl)}
          toolTip={strings.MANAGE}
          type="primary"
        >
          {strings.MANAGE}
        </Button>
      </div>
    </Modal>
  );
};
